/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for UserFeedback controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UserFeedbackRequest, RequestOptions, UserFeedbackResponse } from "../models";

@Injectable({ providedIn: "root" })
export class UserFeedbackService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    submitUserFeedbackApiUserFeedbackPost(userFeedbackRequest: UserFeedbackRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<UserFeedbackResponse>;
    submitUserFeedbackApiUserFeedbackPost(userFeedbackRequest: UserFeedbackRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<UserFeedbackResponse>>;
    submitUserFeedbackApiUserFeedbackPost(userFeedbackRequest: UserFeedbackRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<UserFeedbackResponse>>;
    /** Submit user feedback (thumbs up/down) on AI Assistant responses */
    submitUserFeedbackApiUserFeedbackPost(userFeedbackRequest: UserFeedbackRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/user_feedback`;

        const requestOptions: any = {
            observe: observe as any,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, userFeedbackRequest, requestOptions);
    }
}
